import { render, staticRenderFns } from "./project-tags.vue?vue&type=template&id=5bd81d70&scoped=true&"
import script from "./project-tags.vue?vue&type=script&lang=js&"
export * from "./project-tags.vue?vue&type=script&lang=js&"
import style0 from "./project-tags.vue?vue&type=style&index=0&id=5bd81d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd81d70",
  null
  
)

export default component.exports